export const BEHAVIOR_TRANSFORMERS = Object.freeze([
  // use only lowercase names
  "discovery-topic-list-load-more",
]);

export const VALUE_TRANSFORMERS = Object.freeze([
  // use only lowercase names
  "category-description-text",
  "category-display-name",
  "mentions-class",
  "header-notifications-avatar-size",
  "home-logo-href",
  "home-logo-image-url",
]);
